import EmberObject from '@ember/object';

export default class VoltageRageSignal extends EmberObject {
  minimum; // double
  maximum; // double
  frequency; // double
  warningEnabled; // boolean
}
